<template>
  <v-container>
    <v-card>
      <v-toolbar flat color="grey lighten-2">Overview</v-toolbar>
      Showcase Statistics
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ShowcaseDashboard',
  data: () => ({})
}
</script>

<style scoped></style>
